module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.default,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [(_vm.showName) ? _c('el-form-item', {
    attrs: {
      "label": "字段名",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.default.name),
      expression: "curInput.default.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "maxlength": 64
    },
    domProps: {
      "value": (_vm.curInput.default.name)
    },
    on: {
      "input": function($event) {
        _vm.curInput.default.name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("字段名格式：英文或数字，可带下划线，必须以英文开头")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "字段标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.default.title),
      expression: "curInput.default.title",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.curInput.default.title)
    },
    on: {
      "input": function($event) {
        _vm.curInput.default.title = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提示信息",
      "prop": "tips"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.default.tips),
      expression: "curInput.default.tips",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.curInput.default.tips)
    },
    on: {
      "input": function($event) {
        _vm.curInput.default.tips = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否必填",
      "prop": "is_needed"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.default.is_needed),
      expression: "curInput.default.is_needed"
    }],
    domProps: {
      "value": (_vm.curInput.default.is_needed)
    },
    on: {
      "input": function($event) {
        _vm.curInput.default.is_needed = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": _vm.notNeed
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0,
      "disabled": _vm.notNeed
    }
  }, [_vm._v("否")])])]), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-666aa12b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/commonConfig.vue
// module id = 1899
// module chunks = 2